<form [formGroup]="payHistory">
    <div class="card-body pb-0" #contentToConvert>
        <div class="receipt ">
            <div class="row ">
                <!-- <div class="col-sm-2 mb-3">
                    <img src="../../assets/img/logo-light.png" class="header-brand-img desktop-logo" alt="logo">
                </div>
                <div class="col-sm-10">
                    <h6 class="mra">{{InstuName}}</h6>
                    <h6 class="mra1">Payment Receipt</h6>
                </div> -->
                <div class="col-sm-12">
                    <img src="../../assets/img/logo-light.png" class="header-brand-img reciptLogo desktop-logo" alt="logo">
                    <h6 class="mra">{{InstuName}}</h6>
                    <h6 class="mra1">Payment Receipt</h6>
                </div>
            </div>
            <div class="row">
                <div class="receipt-details">
                    <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Receipt Number:</strong> {{reciptNumber}}</p>
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Date:</strong>{{currentDate | date: 'dd/MM/yyyy'}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <p><strong>College:</strong> {{clgName}} <span id="college"></span></p>
                        </div>
                        <div class="col-sm-6">
                            <p><strong>Course:</strong> {{CoName}} <span id="program"></span></p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6" *ngIf="PreFix != '' ">
                            <p><strong>Rg No/PRN No.:</strong>{{PreFix}}/{{formattedPrn}}</p>
                        </div>
                        <div class="col-sm-6" *ngIf="PreFix == ''">
                            <p><strong>Rg No/PRN No.:</strong>{{formattedPrn}}</p>
                        </div>
                        <div class="col-sm-6" *ngIf="StuName">
                            <p><strong>Name:</strong>{{StuName}}</p>
                        </div>
                        <div class="col-sm-6" *ngIf="!StuName">
                            <p><strong>Name:</strong> {{FirstName}} {{MiddleName}} {{LastName}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- General fee table (used for non-Transcript and for ATTFE/VOD) -->
            <div *ngIf="!Transcript || data.FeeType === 'ATTFE' || data.FeeType === 'VOD'" class="mt-2">
                <table class="styled-table" style="width:100%">
                    <thead>
                        <tr >
                            <th width="40%" class="f600" style="text-align: left !important;">Fee Head</th>
                            <th width="20%" class="f600" style="text-align: right !important;">Fee Paid</th>
                            <th width="20%" class="f600" style="text-align: right !important;">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr  *ngFor="let item of payHistoryData; let i = index">
                            <td style="text-align: left !important;">{{item.Head != null ? item.Head : item.FeeHead}}</td>
                            <td style="text-align: right !important;" *ngIf="Currency == 'INR' ">
                                <span class="currency-symbol Textmrg1">&#8377;{{item.FeeAmt}}</span>
                            </td>
                            <td style="text-align: right !important;" *ngIf="Currency == 'USD' ">
                                <span class="currency-symbol Textmrg1">$ {{item.FeeAmt}}</span>
                            </td>
                            <td style="text-align: right !important;">{{item.FeePaymentDate | date: 'dd/MM/yyyy'}}</td>

                        </tr>
                    </tbody>

                </table>
            </div>
            <!-- && TranscriptData.CertStatus === 'Submitted' -->
            <div *ngIf="Transcript && data.FeeType !== 'ATTFE' && data.FeeType !== 'VOD'" class="mt-2">
                <table class="styled-table" style="width:100%">
                    <thead>
                        <tr >
                            <th width="40%" class="f600" style="text-align: left !important;">Fee Head</th>
                            <th width="20%" class="f600" style="text-align: right !important;">Fee Paid</th>
                            <th width="20%" class="f600" style="text-align: right !important;">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                          *ngFor="let item of payHistoryData; let i = index"
                          [class.subhead]="isSubhead(item.FeeHead)"
                          [class.head]="isHead(item.FeeHead)">
                          <td [class.indented]="isSubhead(item.FeeHead)" style="text-align: left !important;">
                            {{item.Head != null ? item.Head : item.FeeHead}}
                          </td>
                          <td class="tae" style="text-align: right !important;" *ngIf="Currency === 'INR'">
                            <span class="currency-symbol Textmrg1">&#8377;{{item.FeeAmt}}</span>
                          </td>
                          <td class="tae" style="text-align: right !important;" *ngIf="Currency === 'USD'">
                            <span class="currency-symbol Textmrg1">$ {{item.FeeAmt}}</span>
                          </td>
                          <td style="text-align: right !important;">{{item.FeePaymentDate | date: 'dd/MM/yyyy'}}</td>
                        </tr>
                      </tbody>

                </table>
                <ul>
                    <li >Transcript No. Of Set : {{TranscriptData.StuCertCopies}}</li>
                    <li >Delivery Option : {{TranscriptData.DeliveryOpt == 'Hard' ? 'Hard Copy' : (TranscriptData.DeliveryOpt == 'Soft' ? 'Soft Copy' : 'Hard Copy and Soft Copy')}}</li>
                </ul>
                
               <ul>Extra Charges:
                    <li>2190/- per set for transcript.</li>
                    <li>2570/- postal charge(Hard Copy & Out Of India Only).</li>
                </ul>
            </div>
            <div *ngIf="TranscriptData && (data.FeeType === 'TS' || data.FeeType === 'ATTFE' || data.FeeType === 'VOD')" class="mt-2">
                <div *ngIf="!isAttestation && !isVOD; else attestationOrVodDetails">
                    <ul>
                        <li>Transcript No. Of Set : {{TranscriptData.StuCertCopies}}</li>
                        <li>Delivery Option : {{TranscriptData.DeliveryOpt == 'Hard' ? 'Hard Copy' :
                            (TranscriptData.DeliveryOpt == 'Soft' ? 'Soft Copy' : 'Both Hard Copy and Soft Copy')}}</li>
                    </ul>
                    <ul>Extra Charges:
                        <li>2190/- per set for transcript.</li>
                        <li>2570/- postal charge (Hard Copy & Out Of India Only).</li>
                    </ul>
                </div>

                <ng-template #attestationOrVodDetails>
                    <div *ngIf="isAttestation">
                        <ul>
                            <li>Attestation : {{TranscriptData.StuCertCopies}} sets (Base for 7 sets)</li>
                            <li>Delivery Option : {{TranscriptData.DeliveryOpt == 'Hard' ? 'Hard Copy' :
                                (TranscriptData.DeliveryOpt == 'Soft' ? 'Soft Copy' : 'Both Hard Copy and Soft Copy')}}</li>
                        </ul>
                        <!-- <ul>Extra Charges:
                            <li>Base fee for 7 sets: ₹3050</li>
                            <li *ngIf="TranscriptData.StuCertCopies > 7">Additional set fee: ₹800 per extra set ({{TranscriptData.StuCertCopies - 7}} extra)</li>
                            <li>Soft copy delivery: ₹800</li>
                            <li>Hard copy out‑of‑India delivery: ₹2570 per set</li>
                        </ul> -->
                    </div>
                    <div *ngIf="isVOD">
                        <ul>
                            <li>Verification of University Document</li>
                            <li>Delivery Option : {{TranscriptData.DeliveryOpt == 'Hard' ? 'By Air Mail Charges' :
                                (TranscriptData.DeliveryOpt == 'Soft' ? 'By Email Charges' : 'Both By Air Mail Charges and By Email Charges')}}</li>
                            <li *ngIf="TranscriptData.DeliverAt">Delivery Location : {{TranscriptData.DeliverAt == 'IN' ? 'Within India' : 'Out Of India'}}</li>
                        </ul>
                        <ul>Fee Details:
                            <li>Verification Fee: ₹3050</li>
                            <li>Copies Fee: Not Applicable</li>
                            <li *ngIf="TranscriptData.DeliveryOpt == 'Soft' || TranscriptData.DeliveryOpt == 'Both'">By Email Charges: ₹800</li>
                            <li *ngIf="!isStudentWithinIndia() && (TranscriptData.DeliveryOpt == 'Hard' || TranscriptData.DeliveryOpt == 'Both')">By Air Mail Charges: ₹2570</li>
                            <li *ngIf="isStudentWithinIndia() && (TranscriptData.DeliveryOpt == 'Hard' || TranscriptData.DeliveryOpt == 'Both')">By Air Mail Charges: Not Applicable (Within India)</li>
                        </ul>
                    </div>
                </ng-template>
            </div>

            <div class="row">
                <div class="receipt-footer">
                    <div class="row mt-1">
                        
                        <div class="col-sm-6" *ngIf="Currency == 'INR' "> 
                            <b>Total Paid Amount :</b>
                            <span class="currency-symbol Textmrg1">&#8377;{{TotalPaidAmount}}</span></div>
                    
                            <div class="col-sm-6" *ngIf="Currency == 'USD' "> 
                                <b>Total Paid Amount :</b>
                                <span class="currency-symbol Textmrg1">$ {{TotalPaidAmount}}</span></div>
                                <div class="col-sm-6">
                                    <p><strong>Payment Mode:</strong> {{payModeee}} </p>
                                </div>
                        </div>
                    <!-- <div  class="row">
                       
                    </div> -->
                    
                    <div class="row">
                        <!-- <div class="col-sm-6">
                            <p><strong>Signature:</strong></p>
                        </div> -->
                        <div class="col-sm-12" *ngIf="Currency == 'INR' "> 
                            <b>In Words :</b>
                            <span class="currency-symbol linkk Textmrg1">Rupees {{TotalPaidAmountInWords}} Only</span></div>
                    
                            <div class="col-sm-12" *ngIf="Currency == 'USD' "> 
                                <b>In Words :</b>
                                <span class="currency-symbol linkk Textmrg1">Dollars {{TotalPaidAmountInWords}} Only</span></div>
                       
                    </div>
                    <!-- <div class="row">
                        <div class="col-sm-6">
                            <p><strong>Date:</strong> {{currentDate | date: 'dd/MM/yyyy'}}</p>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="row col-sm-12 mb-2 mt-2">
            <div class="col-sm-2 divName offset-8">
                <button type="button" class="btn no-print fr sz btn-primary btn-icon-text floatright mt-1 fr" (click)="close()">
                    <span style="display: contents; align-items: center;">
                        <!-- <img width="20vh" src="../../assets/img/letter-x.gif" style="margin-right: 5px;"> -->
                        Close
                    </span>
                </button>
            </div>
            <div class="col-sm-2 divName" >
                <button type="button" class="btn no-print fr sz btn-primary btn-icon-text floatright mt-1 fr"
                    (click)="downloadAsPDF()">
                    <span  style="display: contents; align-items: center;">
                        Download
                        <!-- <img width="20vh" src="../../assets/img/download img.png" style="margin-right: 5px;"> -->
                    </span>
                </button>
            </div>
        </div>
    </div>
</form>